import { FC } from 'react';
import { useAccessibilityContext } from 'shared/contexts/accessibility-context';
import styles from './styles.module.scss';

// Кнопка-тумблер «Версия для слабовидящих» (в футере).
// Переключатель остаётся в футере и возвращает к обычной версии.
export const AccessibilityButton: FC = () => {
    const { enabled, toggle } = useAccessibilityContext();

    return (
        <button
            type="button"
            className={`a11y-btn-eye ${styles.button}`}
            onClick={toggle}
            aria-pressed={enabled}
            aria-expanded={enabled}
            aria-controls={enabled ? 'a11y-settings' : undefined}
            aria-label={enabled ? 'Обычная версия сайта' : 'Версия сайта для слабовидящих'}
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
            </svg>
            <span>{enabled ? 'Обычная версия сайта' : 'Версия для слабовидящих'}</span>
        </button>
    );
};
